<template>
	<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 22 14" style="enable-background:new 0 0 22 14;" xml:space="preserve">
		<g id="Icon---Hidden" transform="translate(355.000000, 286.000000)">
			<g id="Group-23">
				<path id="Path" class="st0" d="M-342.7-284.3c-0.4,0-0.9-0.1-1.3-0.1c-3.5,0-6.8,1.4-8.9,3.8l-1.4,1.6l1.2,1.3
					c0.6,0.6,1.2,1.1,1.9,1.6"/>
				<path class="st0" d="M-344.3-274c0.1,0,0.2,0,0.3,0c3.5,0,6.8-1.4,9-3.7l1.3-1.4l-1.3-1.5c-0.5-0.6-1.1-1.1-1.8-1.6"/>
				<path class="st0" d="M-344-276.4c1.7,0,3-1.2,3-2.6"/>
				<path class="st0" d="M-344-281.6c-1.7,0-3,1.2-3,2.6"/>
				<path id="Path-7" class="st0" d="M-350.5-272.4l13-13.1"/>
			</g>
		</g>
	</svg>
</template>
<script>
export default {
	name: "IconEyeHidden"
};
</script>
<style lang="scss" scoped>
	.st0{
		fill:none;
		stroke:#BABFC4;
	}
</style>

